export default {"src":"/_next/static/media/lock-solid.36dba412.svg","height":512,"width":448};